import {
  ApiEnveloppe,
  CheckConnexionResponse,
  GetUserResponse,
} from '../../types/types';
import {
  _getArgosV25,
  _post,
  _postArgosV25,
  _postAllHeaders,
  requestType,
} from './_internal';

export const authentication = (payload: {
  login_name: string;
  login_password: string;
}): Promise<GetUserResponse> => {
  return _postAllHeaders({
    request_type: requestType.connexion,
    login_name: payload.login_name,
    login_password: payload.login_password,
  });
};

export const authenticationV25 = (payload: {
  login_name: string;
  login_password: string;
}): Promise<{ success: boolean; user_id: string }> => {
  const route = 'api/login';
  return _postArgosV25({ route, payload: payload });
};

export const checkConnexionV25 = (): Promise<{
  authenticated: boolean;
  user_id: number;
  login_name: string;
  privileges_list: number[];
}> => {
  const route = 'api/me';
  return _getArgosV25({ route });
};

export const logoutV25 = (): Promise<{ success: boolean }> => {
  const route = 'api/logout';
  return _postArgosV25({ route });
};

export const logout = (): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.deconnexion,
  });
};

export const askForPasswordReset = (payload: { email: string }) => {
  return _postAllHeaders({
    email: payload.email,
    request_type: requestType.demande_de_reinitialisation_du_mot_de_passe,
  });
};

export const resetPassword = () => {
  return _postAllHeaders({
    request_type: requestType.reinitialisation_du_mot_de_passe,
  });
};

export const validateCodeVerification = (payload: {
  codeVerification: string;
}) => {
  return _postAllHeaders({
    request_type: requestType.validation_du_code_de_verification,
    verification_code: payload.codeVerification,
  });
};

export const checkConnexion = (): Promise<CheckConnexionResponse> => {
  return _post({ request_type: requestType.information_de_connexion });
};

export const requestPasswordChange = (payload: any) => {
  return _postAllHeaders({
    request_type: requestType.changer_son_mot_de_passe,
    ...payload,
  });
};
